module.exports = __webpack_public_path__ + "static/media/debug.vertex.c3f8cc45.glsl";